<template>
  <div v-if="vessel_detail">
    <el-dialog title="" :visible.sync="showReservedSeats" size="50%" :destroy-on-close="true" :append-to-body="true">

      <div class="row">
        <div class="col-md-12">
          <div style="font-weight: bold;">RESERVED SEATS</div>
          <hr>
          <div v-if="blocked_seats.length">
            <el-table :data="blocked_seats || []" style="width: 100%">

          <el-table-column :min-width="100" class-name="td-actions" label="Seat number">
            <template slot-scope="props">
              <div class="semi-bold">
                {{ props.row.seat_number }}
              </div>
            </template>
          </el-table-column>

          <el-table-column :min-width="100" class-name="td-actions" label="By">
            <template slot-scope="props">
              <div class="semi-bold">
                {{ props.row.created_by }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="Action" width="120">
            <template slot-scope="props">
          
              <el-tooltip
                        class="item"
                        effect="dark"
                        content="Remove reserved seat"
                        placement="top"
                        v-if="isAllowed('tickets', 'update')"
                      >
                        <el-popconfirm
                          confirm-button-text="Yes"
                          cancel-button-text="Cancel"
                          icon="el-icon-warning"
                          icon-color="red"
                          title="Remove reserved seat?"
                          @confirm="handleRemoveReservedSeat(props.row)"
                        >
                          <el-button
                            slot="reference"
                            type="danger"
                            size="mini"
                          >
                            <i class="fa fa-times"></i>
                          </el-button>
                        </el-popconfirm>
                      </el-tooltip>

            </template>
          </el-table-column>

        </el-table>
          </div>

        </div>
        
      </div>
    </el-dialog>

    <el-drawer title="" :visible.sync="showBookngTickets" direction="btt" :before-close="handleClose" size="90%"
      :destroy-on-close="true" :append-to-body="true">
      <div>
        <booking-tickets-list :booking="booking" v-if="booking"></booking-tickets-list>
      </div>
    </el-drawer>

    <h4>{{ vessel_detail.code }} - {{ accommodation.name }}</h4>
    <small class="text-white active-seat padding-5">GRAY - AVAILABLE </small>
    <small class="text-white taken-seat padding-5">YELLOW - TAKEN </small>
    <small class="text-white reserved-seat padding-5">BLUE - RESERVED </small>
    <small class="text-white padding-5" style="background: #3e3f3f;">BLACK - UNAVAILABLE</small>
    <div>
      <br>
      <el-button v-if="allow_block" @click="handleShowReservedSeats">SHOW {{ blocked_seats.length }} RESERVED
        SEATS</el-button>
      <el-button v-if="booking" @click="handleShowBookingTickets">SHOW MANIFEST</el-button>
      <h5 v-if="booking">{{ booking.route.code }} {{  booking.booking_date }} {{  booking.formatted_departure_time }}</h5>
    </div>
    <hr>
    <div class="row" v-if="!ticket && !booking">
      <div class="col-md-2 mb-2">
        <strong>Add Seats</strong>
        <el-input v-model="rows" size="mini">
          <template slot="prepend">Rows</template>
        </el-input>
        <el-input v-model="columns" size="mini">
          <template slot="prepend">Columns</template>
        </el-input>
        <div class="mt-2">
          <el-button size="mini" type="primary" plain @click="handleAddSeats()">Add</el-button>
          <el-button size="mini" type="danger" plain @click="handleRemoveAll()">or Remove all seats</el-button>
        </div>
      </div>
      <div class="col-md-3" v-if="vessel">
        TOTAL ACTIVE SEATS: <br>
        <div style="font-size: 50px;">{{ vessel.total }}</div>
      </div>

    </div>
    <div v-if="!generated_seats.length">No seats </div>
    <div v-for="row, i in generated_seats" :key="i" style="margin-bottom: 20px;min-width: 1000px;">
      <span class="seat-number-box" v-for="col in row.columns" :key="col" :class="{
        'aisle-seat': isAisle(AddLeadingZero(i + 1), col),
        'active-seat': isActive(AddLeadingZero(i + 1), col),
        'taken-seat': isSeatTaken(AddLeadingZero(i + 1), col),
        'reserved-seat': isSeatReserved(AddLeadingZero(i + 1), col),
        'current-seat': isCurrentSeat(AddLeadingZero(i + 1), col),
        'select-seat-box': canCreateTicket(i, col)
      }">
        <div style="padding-left: 5px;">
          <span class="seat-number-text">{{ AddLeadingZero(i + 1) }}{{ col }}</span><br>
          <el-link v-if="!ticket && !booking" style="font-size: 10px;"
            @click="handleAddSpace(AddLeadingZero(i + 1), col)">
            {{ isAisle(AddLeadingZero(i + 1), col) ? 'RM SPACE' : 'ADD SPACE' }}</el-link><br>
          <el-link v-if="!ticket && !booking" style="font-size: 10px;"
            @click="handleBlock(AddLeadingZero(i + 1), col)">{{
              isActive(AddLeadingZero(i + 1), col) ? 'BLOCK' :
            'UNBLOCK' }}</el-link>
          <el-link
            v-if="canTakeSeat(AddLeadingZero(i+1), col)"
            @click="handleTakeSeat(AddLeadingZero(i + 1), col)" class="assign-seat-button"><span
              class="font-15 bold">TAKE</span> <i class="fa fa-sign-out"></i>
          </el-link>

          <el-link v-if="isCurrentSeat(AddLeadingZero(i + 1), col)"
            @click="handleRemoveSeat(AddLeadingZero(i + 1), col)" class="assign-seat-button"><span
              class="font-15 bold">REMOVE</span>
          </el-link>

          <el-link @click="handleAddSeatToCreateTicket(AddLeadingZero(i + 1), col)"
            v-if="canCreateTicket(i, col) && !isSeatAlreadySelected(AddLeadingZero(i + 1), col)"><span
              class="font-15 bold select-seat-number"> SELECT </span>
          </el-link>

          <el-link @click="handleAddSeatToCreateTicket(AddLeadingZero(i + 1), col, 'remove')"
            v-if="canCreateTicket(i, col) && isSeatAlreadySelected(AddLeadingZero(i + 1), col)"><span
              class="bold select-seat-number selected-seat-number" style="font-size: 13px;"> REMOVE </span>
          </el-link>

          <el-link
            v-if="allow_block && booking && !isSeatReserved(AddLeadingZero(i + 1), col) && !isSeatTaken(AddLeadingZero(i + 1), col) && isActive(AddLeadingZero(i + 1), col)"
            @click="handleReserveSeat(AddLeadingZero(i + 1), col)" class="assign-seat-button"><span
              class="font-15 bold">RESERVE</span>
          </el-link>

          <el-link
            v-if="allow_block && booking && !isSeatReserved(AddLeadingZero(i + 1), col) && isSeatTaken(AddLeadingZero(i + 1), col) && isActive(AddLeadingZero(i + 1), col)"
            @click="setNoShow(AddLeadingZero(i + 1), col)" class="assign-seat-button"><span
              class="font-10 bold  hover-red" style="color: #1f4fb0;">SET NO SHOW</span>

          </el-link>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import {
  extend
} from "vee-validate";
import {
  required
} from "vee-validate/dist/rules";
import {
  Vessel
} from '@/resources/vessel'
import {
  Accommodation
} from '@/resources/accommodation'

import {
  Booking
} from '@/resources/booking'

import {
  Ticket
} from '@/resources/ticket'

import {
  BookingBlockedSeat
} from '@/resources/booking_blocked_seat'
import BookingTicketsList from "../Bookings/BookingTicketsList.vue";

extend("required", required);

export default {
  name: 'VesselSeatPlanForm',
  props: ['vessel_detail', 'accommodation',
    'ticket', 'taken_seats', 'booking', 'allow_block', 'allow_create', 'create_ticket',
    'created_ticket_seats'
  ],
  data() {
    return {
      loading: false,
      form: null,
      accommodations: [],
      seats: [],
      generated_seats: [],
      rows: 0,
      columns: 0,
      vessel: null,
      taken_seats_from_booking: [],
      blocked_seats: [],
      showReservedSeats: false,
      selected_seat_number: null,
      selected_seats_for_create: [],
      showBookngTickets: false,
      reserved_seats: [],
      booking_ticket_seats: []
    };
  },
  components: { BookingTicketsList },
  watch: {
    accommodation: function () {
      this.getSeats()
    },
    ticket: function () {
      if (this.ticket && this.ticket.ticket_seat) this.selected_seat_number = this.ticket.ticket_seat.seat_number
    },
    selected_seats_for_create: function () {
      this.$emit('selectedSeats', this.selected_seats_for_create)
    },
    created_ticket_seats: function () {
      this.selected_seats_for_create = this.created_ticket_seats
    }
  },
  created: function () {
    if (this.ticket && this.ticket.ticket_seat) this.selected_seat_number = this.ticket.ticket_seat.seat_number

    this.selected_seats_for_create = this.created_ticket_seats
    this.getSeats()
  },
  methods: {
  canTakeSeat(row, col) {
    if (this.ticket && !this.isSeatTaken(row,col) && this.isActive(row,col)) return true
    // if ticket exist && isSeatNottaken && isActive
    if (this.ticket && this.isSeatReserved(row, col) && !this.isSeatTakenFromBookingTicketsOnly(row,col)) return true
    return false
  },
    handleClose() {
      this.showBookngTickets = false
    },
    handleShowBookingTickets() {
      this.showBookngTickets = true
    },
    isSeatAlreadySelected(row, col) {
      return this.selected_seats_for_create.includes(row + col)
    },
    handleAddSeatToCreateTicket(row, col, option) {
      if (option == 'remove') {
        this.selected_seats_for_create = this.selected_seats_for_create.filter(item => item !== row + col);
        return
      }
      if (this.selected_seats_for_create.length >= 10) {
        this.$notify({
          type: 'danger',
          title: "Attention",
          text: 'A maximum of 10 tickets is allowed per transaction',
        });
        return
      }
      this.selected_seats_for_create.push(row + col)
      this.selected_seats_for_create = [...new Set(this.selected_seats_for_create)].sort();
    },
    canCreateTicket(i, col) {
      return this.booking &&
        !this.isSeatReserved(this.AddLeadingZero(i + 1), col) &&
        !this.isSeatTaken(this.AddLeadingZero(i + 1), col) &&
        this.isActive(this.AddLeadingZero(i + 1), col) &&
        this.create_ticket
    },
    isCurrentSeat(row, col) {
      return this.selected_seat_number == (row + col)
    },
    handleShowReservedSeats() {
      this.showReservedSeats = true
    },
    isSeatReserved(row, col) {
      let seat = row + col
      let is_reserved = false

      this.blocked_seats.forEach(function (blocked_seat) {
        if (blocked_seat.seat_number == seat) is_reserved = true
      })
      return is_reserved
    },
    handleTakeSeat(row, col) {
      this.$emit('takeSeat', row + col)
    },
    handleAddSpace(row, col) {
      let form = {
        seat_number: row + col,
        is_aisle: !this.isAisle(row, col),
        status: this.isActive(row, col),
        accommodation_id: this.accommodation.id,
        vessel_detail_id: this.vessel_detail.id
      }
      this.updateSeat(form)
    },
    handleBlock(row, col) {
      let form = {
        seat_number: row + col,
        is_aisle: this.isAisle(row, col),
        status: this.isActive(row, col) ? 0 : 1,
        accommodation_id: this.accommodation.id,
        vessel_detail_id: this.vessel_detail.id
      }
      this.updateSeat(form)
    },
    handleRemoveAll() {
      this.$loading = true

      Vessel.removeAllSeats(this.vessel_detail.id, {
        accommodation_id: this.accommodation.id
      })
        .then(result => {
          this.seats = []
          this.getSeats()
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    },
    setNoShow(row, col) {

      if (!this.booking) return;

      let seatNumber = row + '' + col;

      this.$confirm(
        `Mark passenger with seat ${seatNumber} as No-Show? This will release the seat.`,
        'Confirm No-Show',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(() => {
          return Booking.setNoShowBySeatNumber(this.booking.id, {
            accommodation_id: this.accommodation.id,
            seat_number: seatNumber,
            is_non_show: true
          });
        })
        .then(result => {
          this.$notify({
            type: 'success',
            title: "Success",
            text: `Passenger ${result.data.passenger_name} with seat ${seatNumber} has been tagged as no-show`,
          });

          this.taken_seats_from_booking = this.taken_seats_from_booking
            .filter(item => item !== seatNumber);
        })
        .catch((err) => {
          // Cancel or error
          if (err !== 'cancel') {
            this.$notify({
              type: 'error',
              title: 'Error',
              text: 'Failed to tag passenger as no-show',
            });
          }
        });
    },
    updateSeat(form) {
      this.$loading = true

      Vessel.updateSeat(this.vessel_detail.id, form)
        .then(result => {
          this.getSeats()
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    },
    AddLeadingZero(number) {
      return number < 10 ? `0${number}` : `${number}`;
    },
    isSeatTakenFromBookingTicketsOnly(row, col) {
      let active = false
      let seats = this.booking_ticket_seats || []
      seats.forEach(function (seat) {
        if (seat == row + col) {
          active = true
        }
      })
      return active
    },
    isSeatTaken(row, col) {
      let active = false
      let seats = this.taken_seats_from_booking || []
      if (!this.taken_seats_from_booking.length) seats = this.taken_seats || []
      seats.forEach(function (seat) {
        if (seat == row + col) {
          active = true
        }
      })
      return active
    },
    isActive(row, col) {
      let active = false
      let self = this

      this.seats.forEach(function (seat) {
        if (seat.seat_number == row + col) {
          if (seat.status == 1) active = true
        }
      })
      return active
    },
    isAisle(row, col) {
      let aisle = false
      let self = this

      this.seats.forEach(function (seat) {
        if (seat.seat_number == row + col) {
          if (seat.is_aisle) aisle = true
        }
      })
      return aisle
    },
    updateColumn(i) {
      let self = this
      this.generated_seats.forEach(function (seat, index) {
        if (index == i) {
          seat.columns = []
          for (let c = 1; c <= seat.col_size; c++) {
            seat.columns.push(self.numberToAlphabet(c))
          }
        }
      })
    },
    alphabethToNumber(letter) {
      // Convert the letter to uppercase to handle both cases
      let uppercaseLetter = letter.toUpperCase();

      // ASCII value of 'A'
      let asciiValueOfA = 'A'.charCodeAt(0);

      // Get the ASCII value of the input letter
      let asciiValueOfInput = uppercaseLetter.charCodeAt(0);

      // Calculate the position by subtracting the ASCII value of 'A'
      let position = asciiValueOfInput - asciiValueOfA + 1;

      // Return the position
      return position;
    },
    numberToAlphabet(number) {
      if (number < 1 || number > 26) {
        return "Number out of range (1-26)";
      }

      return String.fromCharCode(64 + number); // 64 is the ASCII code for 'A'
    },
    handleAddSeats() {
      this.$loading = true
      Vessel.addSeats(this.vessel_detail.id, {
        accommodation_id: this.accommodation.id,
        rows: this.rows,
        columns: this.columns
      })
        .then(result => {
          this.getSeats()
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })

    },
    generateSeats(row = 0, col = 0) {
      this.generated_seats = []
      for (let r = 0; r < parseInt(row); r++) {
        let addtlRow = {
          columns: [],
          col_size: 0
        }
        for (let c = 1; c <= col; c++) {
          addtlRow.columns.push(this.numberToAlphabet(c))
        }

        addtlRow.col_size = addtlRow.columns.length

        this.generated_seats.push(addtlRow)
      }
      this.getTakenSeatsFromBooking()
    },
    getTakenSeatsFromBooking() {
      if (!this.booking) return

      this.$loading = true
      Booking.getTakenSeats(this.booking.id, {
        accommodation_id: this.accommodation.id
      })
        .then(result => {
          this.taken_seats_from_booking = result.data.seats
          this.reserved_seats = result.data.reserved_seats || []
          this.bookng_ticket_seats = result.data.bookng_ticket_seats || []
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    },
    getSeats() {
      if (!this.vessel_detail) return
      this.$loading = true
      Vessel.getSeats(this.vessel_detail.id, {
        accommodation_id: this.accommodation.id
      })
        .then(result => {
          this.vessel = result.data.vessel
          if (result.data.vessel_seats) this.seats = result.data.vessel_seats
          this.generateSeats(parseInt(result.data.last_row_seat), this.alphabethToNumber(result.data.last_column_seat))
          if ((this.booking || this.ticket) && this.accommodation) {
            this.getBlockedSeats()
          }
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    },
    getAccommodations() {
      this.$loading = true
      Accommodation.get({
        params: {}
      })
        .then(result => {
          if (result.data.accommodations)
            this.accommodations = result.data.accommodations
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    },
    async getBlockedSeats() {
      let booking = this.booking
      let accommodation = this.accommodation
      if (this.ticket && !this.booking) booking = this.ticket.booking
      if (!this.ticket && this.booking) booking = this.booking
      if (!this.ticket && !this.booking) return

      if (!accommodation && this.ticket) accommodation = this.ticket.accommodation
      if (!booking) return
      this.$loading = true
      try {
        const result = await BookingBlockedSeat.get(booking.id, {
          accommodation_id: accommodation.id
        })

        this.blocked_seats = (result.data && result.data.booking_blocked_seats) || []

      } catch (e) {
        console.log("error", e)
      } finally {
        this.$loading = false
      }
    },
    handleRemoveSeat(row, col) {
      let seat_number = row + col
      if (this.loading) return

      this.loading = true
      Ticket.saveSeatNumber(this.ticket.id, { seat_number: seat_number, remove: 1 })
        .then(result => {
          this.$notify({
            type: 'success',
            title: "Success",
            text: 'Seat number removed',
          });
          this.selected_seat_number = null
          this.generated_seats.splice()
          this.generated_seats = this.generated_seats.filter(item => item !== seat_number);
          this.$emit('removeSeat', seat_number)
        })
        .catch(() => {

        }).finally(() => {
          this.loading = false
        })

    },
    handleRemoveReservedSeat(blocked_seat) {
      if (this.loading) return

      this.loading = true
      BookingBlockedSeat.delete(this.booking.id, { booking_blocked_seat_id: blocked_seat.id })
        .then(result => {
          this.$notify({
            type: 'success',
            title: "Success",
            text: 'Seat number removed',
          });
          this.getSeats()
        })
        .catch(() => {

        }).finally(() => {
          this.loading = false
        })
    },
    handleReserveSeat(row, col) {
      let seat_number = row + col
      if (this.loading) return

      this.loading = true
      BookingBlockedSeat.create(this.booking.id, { accommodation_id: this.accommodation.id, seat_number: seat_number })
        .then(result => {
          this.blocked_seats.push(result.data.booking_blocked_seat)
          this.taken_seats_from_booking.push(seat_number)
        })
        .catch(() => {

        }).finally(() => {
          this.loading = false
        })

    },

  }
}
</script>

<style></style>
